import { render, staticRenderFns } from "./FaturamentoListFiltroModalItemInput.vue?vue&type=template&id=53d106db"
import script from "./FaturamentoListFiltroModalItemInput.vue?vue&type=script&lang=js"
export * from "./FaturamentoListFiltroModalItemInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports